// src/components/widgets/MonitorWidgetCreator.tsx
import React from 'react';

const MonitorWidgetCreator: React.FC = () => {
  return <div>Monitor Widget Creator - Coming Soon</div>;
};

export default MonitorWidgetCreator;